var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1336 8.49083L10.8836 3.24083C10.6492 3.00658 10.3314 2.875 10 2.875C9.66863 2.875 9.35081 3.00658 9.11641 3.24083L2.86641 8.49083C2.74978 8.6066 2.65732 8.7444 2.59442 8.89623C2.53151 9.04805 2.49942 9.21086 2.50001 9.3752V16.8752C2.50001 17.041 2.56586 17.1999 2.68307 17.3171C2.80028 17.4344 2.95925 17.5002 3.12501 17.5002H16.875C17.0408 17.5002 17.1997 17.4344 17.3169 17.3171C17.4342 17.1999 17.5 17.041 17.5 16.8752V9.3752C17.5006 9.21086 17.4685 9.04805 17.4056 8.89623C17.3427 8.7444 17.2502 8.6066 17.1336 8.49083ZM16.25 16.2502H3.75001V9.3752L9.35681 4.66548C9.72871 4.35309 10.2713 4.35309 10.6432 4.66548L16.25 9.3752V16.2502Z",
    fill: "#616E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2931 9C10.7735 9 10.3124 9.19825 10 9.53899C9.68759 9.19825 9.22647 9 8.7069 9C8.25437 9.00053 7.82053 9.17453 7.50054 9.48385C7.18056 9.79316 7.00055 10.2125 7 10.65C7 12.4584 9.73647 13.9034 9.85284 13.9641C9.89807 13.9877 9.94863 14 10 14C10.0514 14 10.1019 13.9877 10.1472 13.9641C10.2635 13.9034 13 12.4584 13 10.65C12.9995 10.2125 12.8194 9.79316 12.4995 9.48385C12.1795 9.17453 11.7456 9.00053 11.2931 9Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFill);
export default __webpack_public_path__ + "static/media/HouseFill.8d04501a73eb617c2023f5df768a6c58.svg";
export { ForwardRef as ReactComponent };